import moment from "moment";

/**
 * @param {string} start
 * @param {string} end
 * @returns {string}
 */
export const FormattedDate = ({start, end}) => {
    const monthDayYearFormat = 'MMM D, YYYY';
    const hourAndMinuteFormat = 'h:mm A'

    const startMoment = moment.utc(start)
    const endMoment = moment.utc(end)

    const startDate = startMoment.format(monthDayYearFormat)
    const startTime = startMoment.format(hourAndMinuteFormat)
    const endDate = endMoment.format(monthDayYearFormat)
    const endTime = endMoment.format(hourAndMinuteFormat)

    // Example: Single-day event
    // MAY 5, 2022 | 8:00 AM - 8:00 PM
    const singleDayEventOutput = `${startDate} | ${startTime} - ${endTime}`

    // Example: Multi-day event
    // FEB 19, 2022 - MAR 19, 2022
    const multiDayEventOutput = `${startDate} - ${endDate}`

    if (startDate === endDate) {
        return singleDayEventOutput
    }

    return multiDayEventOutput
}
